const prevArrow = `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="https://cdn.shopify.com/s/files/1/0528/0297/7982/files/Arrow_Circle_L-svg.png?v=1619737203"></button>`
const nextArrow = `<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="https://cdn.shopify.com/s/files/1/0528/0297/7982/files/Arrow_Circle_R-svg.png?v=1619737203"></button>`

window.addEventListener('DOMContentLoaded', function(){
  const selectors = {
    mainSlider: '.hc-image-slider'
  }
  $(selectors.mainSlider).slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    fade: true,
    adaptiveHeight:true,
    prevArrow,
    nextArrow,
    
  });
})